import { Component, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { deliveryEtaLine } from 'src/app/provider/provider-warehouse-delivery.util';
import { deliveryForReceiver } from 'src/app/provider/provider-warehouse-route.util';
import { AppState } from 'src/app/redux/app.state';
import { SupportService } from 'src/app/support.service';
import { Product, ProductInProviderWarehouse, User } from 'src/typings';

@Component({
  selector: 'app-product-stock-list',
  templateUrl: './product-stock-list.component.html',
  styleUrls: ['./product-stock-list.component.scss']
})
export class ProductStockListComponent implements OnDestroy {
  @Input() product: Product | undefined;

  @Input() receiverWarehouseId: number | null | undefined;

  storeSusbcription: Subscription;

  user: User | undefined;

  constructor(private store: Store<AppState>, public supportService: SupportService) {
    this.storeSusbcription = this.store.subscribe((data) => {
      this.user = data.user.info;
    });
  }

  get ourStockToolTip() {
    return (
      this.getOurStockWarehousesInMyCity()?.reduce((a, b) => {
        return a + `${b.warehouse.description} : ${b.quan} \n`;
      }, '') || ''
    );
  }

  get providerStockInMyCity() {
    return (
      this.getProviderWarehousesInMyCity()?.reduce((a, b) => {
        const eta = deliveryEtaLine(
          deliveryForReceiver(
            b.providerWarehouse,
            this.receiverWarehouseId === undefined
              ? this.user?.defaultWarehouse?.id
              : this.receiverWarehouseId
          )
        );
        return (
          a +
          `${b.providerWarehouse.provider.description} : ${this.supportService.formatMoney(
            b.price
          )}${eta ? ' — ' + eta : ''} \n`
        );
      }, '') || ''
    );
  }

  get providerStockOutMyCity() {
    return (
      this.getProviderWarehousesOutMyCity()?.reduce((a, b) => {
        const eta = deliveryEtaLine(
          deliveryForReceiver(
            b.providerWarehouse,
            this.receiverWarehouseId === undefined
              ? this.user?.defaultWarehouse?.id
              : this.receiverWarehouseId
          )
        );
        return (
          a +
          `${b.providerWarehouse.provider.description} : ${this.supportService.formatMoney(
            b.price
          )}${eta ? ' — ' + eta : ''} \n`
        );
      }, '') || ''
    );
  }

  ngOnDestroy() {
    this.storeSusbcription.unsubscribe();
  }

  getWarehouse() {
    if (!this.product || !this.user) return;
    const warehouse = this.product.stock.find((wh) => {
      return wh.warehouse.id === this.user?.defaultWarehouse.id;
    });
    return warehouse;
  }

  getMyWhQuan() {
    const warehouse = this.getWarehouse();
    return warehouse?.quan || 0;
  }

  getOurStockInMyCity() {
    if (!this.product) return;
    return this.product.stock.reduce((quan, warehouse) => {
      if (
        warehouse.warehouse.city.description === 'Запорожье' &&
        warehouse.warehouse.id !== this.user?.defaultWarehouse.id
      ) {
        return quan + warehouse.quan;
      }
      return quan;
    }, 0);
  }

  getOurStockWarehousesInMyCity() {
    if (!this.product) return;
    return this.product.stock
      .filter((row) => {
        return (
          row.warehouse.id !== this.user?.defaultWarehouse.id &&
          row.warehouse.city.description === 'Запорожье'
        );
      })
      .sort((a, b) => (a.warehouse.description > b.warehouse.description ? 1 : -1));
  }

  getProviderStockInMyCity() {
    if (!this.product) return;
    return this.product.providerStock?.reduce((quan, warehouse) => {
      if (warehouse.providerWarehouse.city.description === 'Запорожье') {
        quan += warehouse.quan;
      }
      return quan;
    }, 0);
  }

  getProviderWarehousesInMyCity() {
    if (!this.product) return;
    return this.product.providerStock?.filter((row) => {
      return row.providerWarehouse.city.description === 'Запорожье';
    });
  }

  getProviderStockOutMyCity() {
    if (!this.product) return;
    return this.product.providerStock?.reduce((quan, warehouse) => {
      if (warehouse.providerWarehouse.city.description !== 'Запорожье') {
        quan += warehouse.quan;
      }
      return quan;
    }, 0);
  }

  getProviderWarehousesOutMyCity() {
    if (!this.product) return;
    return this.product.providerStock
      ?.filter((row) => {
        return row.providerWarehouse.city.description !== 'Запорожье';
      })
      .reduce((a: ProductInProviderWarehouse[], b) => {
        const index = a.findIndex(
          (row) => row.providerWarehouse.provider.id === b.providerWarehouse.provider.id
        );
        if (index === -1) {
          a.push(b);
        }
        return a;
      }, []);
  }

  getAdditionalWarehouses() {
    if (!this.product || !this.user) return;
    return this.product.stock
      .filter((wh) => {
        return wh.warehouse.id !== this.user?.defaultWarehouse.id;
      })
      .map((wh) => {
        return `${wh.warehouse.description} - ${wh.quan} - ${wh.cell || ''}`;
      })
      .sort();
  }
}
